import React from "react";
import {Modal} from "react-bootstrap";
import {Form, Formik} from "formik";
import {FormattedMessage, injectIntl} from "react-intl";
import {shallowEqual, useSelector} from "react-redux";
import {getDocumentsValidationSchema} from "../../../../../../_intesys/_helpers";
import ErrorAlert from "../../../../Common/error-alert/ErrorAlert";
import {faSave, faTimes} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import DocumentEditDialogFormFields from "./DocumentEditDialogFormFields";


export function DocumentEditDialogForm({saveDocument, document, documentError, folderType, folderBrand, isLoading, onHide, isCreating, isUpdating, showSaveButton, intl}) {

    const {folderTypesExt, user, dealers} = useSelector(
        (state) => ({
            folderTypesExt: state.configurations.folderTypesExt,
            user: state.auth.user,
            dealers: state.dealers.dealers
        }),
        shallowEqual
    );

    const isEdit = document.id > 0;

    const DocumentEditSchema = getDocumentsValidationSchema(isEdit, folderType, folderTypesExt, dealers, user);

    return (
        <>
            <Formik
                enableReinitialize={true}
                initialValues={document}
                validationSchema={DocumentEditSchema}
                onSubmit={(values) => saveDocument(values)}
            >
                {({handleSubmit, values, setFieldValue}) => (
                    <>
                        <Modal.Body className="overlay overlay-block cursor-default">
                            {isLoading && (
                                <div className="overlay-layer bg-transparent">
                                    <div className="spinner spinner-lg spinner-success"/>
                                </div>
                            )}
                            <Form className="form form-label-right">

                                <ErrorAlert error={documentError}/>

                                <DocumentEditDialogFormFields
                                    isEdit={isEdit}
                                    folderType={folderType}
                                    folderBrand={folderBrand}
                                    documentType={values.type}
                                    setFieldValue={setFieldValue}
                                />
                            </Form>
                        </Modal.Body>
                        <Modal.Footer>
                            <button
                                type="button"
                                onClick={onHide}
                                className="btn btn-light btn-elevate"
                                disabled={isCreating || isUpdating}
                            >
                                <FontAwesomeIcon icon={faTimes} className={"mr-1"}/>
                                <FormattedMessage id={"GENERIC.CANCEL"}/>
                            </button>
                            {showSaveButton &&
                                <button
                                    type="submit"
                                    onClick={() => handleSubmit()}
                                    className="btn btn-primary btn-elevate ml-3"
                                    disabled={isCreating || isUpdating}
                                >
                                    <FontAwesomeIcon icon={faSave} className={"mr-1"}/>
                                    <FormattedMessage id={"GENERIC.SAVE"}/>
                                </button>
                            }
                        </Modal.Footer>
                    </>
                )}
            </Formik>
        </>
    );

}


export default injectIntl(DocumentEditDialogForm);
